var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 52,
    viewBox: "0 0 40 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1306 37.1875L19.8452 0H0V33.9538L23.1306 37.1875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7744 33.9538V11.3179L31.6902 8.0842L28.4564 0H19.8452L19.8969 37.1875L39.7744 33.9538Z",
    fill: "#E8E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4564 11.3179V0L39.7743 11.3179H28.4564Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7745 33.9539H0V51.7393H39.7745V33.9539Z",
    fill: "#FC0F1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.46 38.9995C14.4279 38.9995 15.5601 39.9668 15.5601 41.6818C15.5601 43.4848 14.4278 44.5291 12.46 44.5291H11.0639V46.6949H9.10712V38.9995H12.46ZM11.0639 42.9901H12.3611C13.2187 42.9901 13.7132 42.5612 13.7132 41.7478C13.7132 40.9452 13.2185 40.5386 12.3611 40.5386H11.0639V42.9901Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1673 38.9995C22.5858 38.9995 24.2567 40.5605 24.2567 42.8471C24.2567 45.1228 22.5637 46.6949 20.0901 46.6949H16.858V38.9995H20.1673ZM18.815 45.1337H20.2112C21.4094 45.1337 22.2668 44.2103 22.2668 42.8582C22.2668 41.495 21.3654 40.5605 20.1231 40.5605H18.8149V45.1337H18.815Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5227 40.5386V42.3195H30.9746V43.8587H27.5227V46.695H25.5659V38.9996H31.2714V40.5387H27.5227V40.5386Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/Placeholder.8157452cac03f151f67ad77b3f862dbb.svg";
export { ForwardRef as ReactComponent };